module.exports = __webpack_public_path__ + "static/media/icon-pbls.3819c359.svg";